let szenedata = 6;
import { sitePos } from "./sitepos";

sitePos(szenedata);